import tree from 'url:/images/tree-icon.svg'
import home from 'url:/images/home-icon.svg'
import building from 'url:/images/building-icon.svg'
import dropdownArrow from 'url:/images/dropdown-arrow.svg'
import checkiconArrow from 'url:/images/check-icon.svg'
import dropdownGrayArrow from 'url:/images/dropdown-arrow-gray.svg';
const data = {
    h1: 'Berechnen Sie jetzt den Wert Ihrer Immobilie.',
    leftParaGraph: 'Lohnt sich ein Immobilienverkauf? Finden Sie es heraus mit unserem Online Tool.',
    leftListContent: {
        li1: 'Erhalten Sie ein Ergebnis in nur 3 Minuten',
        li2: 'Die Berechnung ist für Sie kostenfrei',
        li3: 'Unser Rechner ist völlig unverbindlich'
    },
    rightContent: {
        h1: 'Wie viel ist Ihre Immobilie wert?',
        dropDownLabel: 'Unterkategorie',
        ctaButtonParagraph: 'Bereits mehr als 574.029 Menschen haben Ihre Immobilie von Homeday bewerten lassen.',
        ctaButtonMobileText: 'Jetzt Immobilie bewerten',
        ctaButtonDesktopText: 'Kostenlose Bewertung starten',
        errorText: 'Bitte wählen Sie aus'
    }
}
export class CustomWidget{
    constructor({dimensions = 'desktop'}) {
        
        this.selectedId = 'A';
        this.selectedUrl = 'https://www.homeday.de/de/immobilienbewertung/?utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung';
        this.cardTypes = [
            { 
                type: 'A', 
                color: 'red',
                image: tree,
                name: 'Grundstück', 
                urls: [ {
                    tag: 'Wählen Sie die Kategorie', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=plot&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung', disabled: true
                },
                    ]
                },
                {
                    type: 'B', 
                    color: 'green',  
                    image: home,
                    name: 'Haus',
                    urls: [
                        {
                            tag: 'Wählen Sie die Kategorie', url: '', disabled: true
                        },
                        {
                            tag: 'Einfamilienhaus', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=house&property_type_detailed=single_family_house&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'Mehrfamilienhaus', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=house&property_type_detailed=multi_family_house&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'Doppelhaushälfte', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=house&property_type_detailed=semidetached_house&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'Mittel-Reihenhaus', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=house&property_type_detailed=mid_terrace_house&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'End-Reihenhaus', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=house&property_type_detailed=end_terrace_house&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'Bungalow', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=house&property_type_detailed=bungalow&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        }
                    ]
                }, 
                {
                    type: 'C', 
                    color: 'blue',  
                    image: building,
                    name: 'Wohnung',
                    urls: [
                        {
                            tag: 'Wählen Sie die Kategorie', url: '', disabled: true
                        },
                        {
                            tag: 'Souterrain', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=apartment&property_type_detailed=half_basement&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'Erdgeschoss', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=apartment&property_type_detailed=ground_floor&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'Etagenwohnung', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=apartment&property_type_detailed=apartment&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'Dachgeschoss', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=apartment&property_type_detailed=roof_storey&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'Maisonette', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=apartment&property_type_detailed=maisonette&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        },
                        {
                            tag: 'Loft', url: 'https://www.homeday.de/de/immobilienbewertung/?property_type=apartment&property_type_detailed=loft&utm_medium=partner&utm_source=spiegel&utm_campaign=widget&utm_content=immobilienbewertung'
                        }
                    ]
                }
            ];
            this.selectedOptions = this.cardTypes[0].urls;
           
        this.createMetaTag();    
        this.createStyles();
        this.initialize();


    }

    createMetaTag() {
        const meta = document.createElement('meta');
        meta.setAttribute("charset", "utf-8");

        const meta1 = document.createElement('meta');
        const meta2 = document.createElement('meta');
        const meta3 = document.createElement('meta');
        const meta4 = document.createElement('meta'); 
        meta1.name="viewport";
        meta1.content="width=device-width, minimum-scale=1.0, maximum-scale=1.0";
        meta2.name="format-detection";
        meta2.content="telephone=no";
        meta3.name="keywords";
        meta3.content="";
        meta4.name="description";
        meta4.content="";
        const link = document.createElement("link");
        link.rel="preconnect";
        link.href="https://fonts.gstatic.com";
        const link1 = document.createElement("link");
        link1.rel="stylesheet";
        link1.href= "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap";
        meta.appendChild(meta1)
        meta.appendChild(meta2)
        meta.appendChild(meta3)
        meta.appendChild(meta4)
        meta.appendChild(link);
        meta.appendChild(link1);
        document.head.appendChild(meta)
    }   

 

    initialize() {
        document.body.classList.add('h_d_widget_body');
        this.widgetWrapper  =  document.createElement('div');
        this.widgetWrapper.classList.add('h_d_widget-wrapper');
        document.body.appendChild(this.widgetWrapper);
        this.widgetOuter = document.createElement('div');
        this.widgetOuter.classList.add('h_d_widget-outer');
        this.widgetMain = document.createElement('div');
        this.widgetMain.classList.add('h_d_widget-main');
        this.widgetWrapper.appendChild(this.widgetOuter);
        this.widgetOuter.appendChild(this.widgetMain);
        this.createLeftContent();
        this.createRightContent();
        
    }
        

        createLeftContent() {
            const leftMain = document.createElement('div');
            leftMain.classList.add('h_d_main-left');
            const h1 = document.createElement('h1');
            h1.textContent = data.h1;
            const p = document.createElement('p');
            p.textContent = data.leftParaGraph;
            const ul  = document.createElement('ul');
            ul.classList.add('h_d_list');
            const li1 = document.createElement('li')
            li1.textContent = data.leftListContent.li1;
            const li2 = document.createElement('li')
            li2.textContent = data.leftListContent.li2;
            const li3 = document.createElement('li')
            li3.textContent = data.leftListContent.li3;
            ul.appendChild(li1);
            ul.appendChild(li2);
            ul.appendChild(li3);
            leftMain.appendChild(h1)
            leftMain.appendChild(p);
            leftMain.appendChild(ul);
            this.widgetMain.appendChild(leftMain);
        }

        createRightContent() {
            const rightMain = document.createElement('div');
            rightMain.classList.add('h_d_main-right');
            const h1 = document.createElement('h1');
            h1.classList.add('h_d_mobilr-title');
            h1.textContent = data.rightContent.h1
            
            const radioUl  = document.createElement('ul');
            radioUl.classList.add('h_d_radio-btn-sec');
            const cardsData =JSON.parse(JSON.stringify(this.cardTypes));
            cardsData.forEach((item) => {
                const radioLi = document.createElement('li');
                radioLi.classList.add('h_d_radio');
                const radioDiv = document.createElement('div');
                radioDiv.classList.add('h_d_radiobtn');
                radioDiv.id = item.type
                radioDiv.classList.add(`radio-div-${item.type}`)
                const image = document.createElement('img');
                image.src = item.image;
                image.id = item.type
                const span = document.createElement('span');
                span.textContent = item.name;
                span.id = item.type
                radioDiv.appendChild(image);
                radioDiv.appendChild(span);
                radioDiv.addEventListener('click', this.handleCardClickEvent.bind(this))
                radioLi.appendChild(radioDiv);
                radioUl.appendChild(radioLi);
            })
            rightMain.appendChild(h1);
            rightMain.appendChild(radioUl);
            const selectBoxOuter = this.createDropDown();
            const ctaButtonSection = this.createCtaButton();
            rightMain.appendChild(selectBoxOuter);
            rightMain.appendChild(ctaButtonSection);
            this.widgetMain.appendChild(rightMain);
            setTimeout(() => {
                window.addEventListener('resize', this.handResize)
            }, 2000)
        }

        createDropDown() {
            const selectBoxOuter = document.createElement('div');
            selectBoxOuter.classList.add('h_d_select-box-outer');
            
             this.select = document.createElement('select');
             this.select.classList.add('h_d_selectbox');
            // select.classList.add('error')
            this.select.id='h_d_selectbx';

            this.selectedOptions.forEach((option, index) => {
                const optionElement = document.createElement('option');
                optionElement.classList.add('option', `${index}-option`);
                optionElement.value = option.url
                optionElement.textContent = option.tag;
                this.select.appendChild(optionElement);
            })

            const label = document.createElement('label');
            label.classList.add('h_d_select-label');
            label.htmlFor='h_d_selectbx';
            label.textContent = data.rightContent.dropDownLabel;
            const span = document.createElement('span');
            span.classList.add('error-txt');
            span.id ='error-txt';

            selectBoxOuter.appendChild(this.select);
            selectBoxOuter.appendChild(label);
            selectBoxOuter.appendChild(span);

            return selectBoxOuter

        }

        handleCardClickEvent(event) {
        this.selectedUrl = '';
        this.selectedId = event.target.getAttribute('id');
        const cards = document.getElementsByClassName('h_d_radiobtn');
        this.select.classList.remove('error');
        document.getElementById('error-txt').textContent = '';
        for(let i = 0 ; i < cards.length; i++) {
            cards[i].classList.remove('active')
        }
        const selectedCard = document.getElementsByClassName(`radio-div-${this.selectedId}`)[0]
        selectedCard.classList.add('active')
        this.selectedOptions = this.cardTypes.find(ob => ob.type === this.selectedId).urls;
        if(this.selectedOptions.length > 1) {
            for (let i = this.select.options.length-1; i >= 0; i--) {
                this.select.options[i] = null;
            }
            this.select.disabled = false;
            this.button.disabled = false;
            this.button.classList.remove('disable')
            this.selectedOptions.forEach((option, index) => {
                const optionElement = document.createElement('option');
                optionElement.classList.add('option', `${index}-option`);
                optionElement.value = option.url
                optionElement.textContent = option.tag;
                this.select.appendChild(optionElement);
            });
        } else {
            for (let i = this.select.options.length-1; i > 0; i--) {
                this.select.options[i] = null;
            }
            this.select.disabled = true;
            console.log(this.selectedOptions[0].url, 'asas')
            this.selectedUrl = this.selectedOptions[0].url
        }
        this.select.addEventListener('change', this.handleChangeDropDown.bind(this))
    }

    createCtaButton() {
        const buttonSection = document.createElement('div');
        buttonSection.classList.add('h_d_btn-section');
        this.button = document.createElement('button');
        this.button.classList.add('h_d_p-btn');
        const spanFormText = document.createElement('span');
        spanFormText.classList.add('h_d_form-txt');
        spanFormText.textContent = data.rightContent.ctaButtonParagraph;
        this.button.addEventListener('click', this.handleCtaButton.bind(this))
        this.button.textContent = window.innerWidth > 767 ? data.rightContent.ctaButtonDesktopText : data.rightContent.ctaButtonMobileText;
        buttonSection.appendChild(this.button);
        buttonSection.appendChild(spanFormText);
        
        return buttonSection;
    }

    handResize() {
                
            if(window.innerWidth < 768 ) {
                console.log("ayush")
                document.getElementsByClassName('h_d_p-btn')[0].textContent =  data.rightContent.ctaButtonMobileText
            } else {
                document.getElementsByClassName('h_d_p-btn')[0].textContent =  data.rightContent.ctaButtonDesktopText
            }
        
    }
    
     handleChangeDropDown(event) {
        this.select.classList.remove('error');
        document.getElementById('error-txt').textContent = '';
        this.selectedUrl = event.target.value;
    }

    handleCtaButton(event) {
        if(this.selectedUrl === '') {
            this.select.classList.add('error');
            document.getElementById('error-txt').textContent = data.rightContent.errorText;
        } else {
            window.open(this.selectedUrl, '_blank')
        }
    }

    createStyles() {
        const styleTag = document.createElement('style');
        document.head.appendChild(styleTag);
        styleTag.innerHTML = `
        /* reset css */
        .h_d_widget_body { margin: 0; font-family: 'Source Sans Pro', sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }
        .h_d_widget_body * { outline: none; -webkit-box-sizing: border-box; box-sizing: border-box; }
        .h_d_widget-wrapper select { font-family: 'Source Sans Pro', sans-serif; -webkit-appearance: none; -moz-appearance: none; appearance: none; }
        .h_d_widget-wrapper select::-ms-expand { display: none; }
        .h_d_widget-wrapper button { font-family: 'Source Sans Pro', sans-serif; border: none; margin: 0; padding: 0; width: auto;    /* inherit font & color from ancestor */    /* Normalize. Cannot be changed from  in Firefox 4+. */
        line-height: normal;    /* Corrects font smoothing for webkit */ -webkit-font-smoothing: inherit; -moz-osx-font-smoothing: inherit;    /* Corrects inability to style clickable  types in iOS */ -webkit-appearance: none; }
        
        /* reset css */
        .h_d_mobilr-title { display: none; }
        .h_d_widget-wrapper { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center; font-family: 'Source Sans Pro', sans-serif; color: #495D75; font-weight: 400; font-size: 14px; line-height: 22px; background-color: #E5E5E5; min-height: 100vh; }
        .h_d_widget-outer { background-color: #fff; padding: 31px 22px; max-width: 616px; overflow: hidden; position: relative; z-index: 1; }
        .h_d_widget-main { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; -webkit-box-orient: horizontal; -webkit-box-direction: normal; -ms-flex-direction: row; flex-direction: row; }
        .h_d_main-left { max-width: calc(100% - 306px); padding: 0 16px; position: relative; z-index: 1; }
        .h_d_main-left:before{ background-color: #F5F9FF; content: ''; position: absolute; top: -50%; right: 0; height: 200%; width: 200%; z-index: -1; }
        .h_d_main-right { max-width: 306px; padding-left: 20px; position: relative; z-index: 1;}
        .h_d_widget-wrapper h1 { font-size: 20px; line-height: 30px; color: #1C3553; margin-bottom: 30px; font-weight: 700; }
        .h_d_widget-wrapper p { margin-bottom: 17px; }
        
        /* list style */
        .h_d_widget-wrapper ul,
        .h_d_list { list-style: none; margin: 0; padding: 0; }
        .h_d_list li { position: relative; padding-left: 25px; font-size: 12px; line-height: 16px; margin-bottom: 14px; }
        .h_d_list li:before { content: ''; position: absolute; left: 0; top: 3px; height: 10px; width: 13px; background-image: url(${checkiconArrow}); background-size: 13px 10px; background-repeat: no-repeat; background-position: center center; }
        /* list style */
        
        /* radio btn css */
        .h_d_radio-btn-sec { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-orient: horizontal; -webkit-box-direction: normal; -ms-flex-direction: row; flex-direction: row; -ms-flex-wrap: wrap; flex-wrap: wrap; padding: 4px 0 !important; margin: 0 0 26px !important; }
        .h_d_radio { margin-right: 8px; width: 90px; }
        .h_d_radio-btn-sec .h_d_radio:last-child { margin-right: 0; }
        .h_d_radiobtn { height: 90px; width: 90px; background-color: #fff; border-radius: 4px; padding: 12px 15px; text-align: center; -webkit-box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.35); box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.35); position: relative; cursor: pointer; -webkit-transition: all 0.3s ease-in-out; -o-transition: all 0.3s ease-in-out; transition: all 0.3s ease-in-out; }
        .h_d_radiobtn:hover{-webkit-transform: translateY(-2px); -moz-transform: translateY(-2px); -ms-transform: translateY(-2px); -o-transform: translateY(-2px); transform: translateY(-2px);}
        .h_d_radiobtn:hover span{color: #2988FF;}
        .h_d_radiobtn:hover:before,
        .h_d_radiobtn.active:before { content: ''; position: absolute; left: 0; right: 0; top: 0; bottom: 0; border: 3px solid #2988FF; border-radius: 2px; -webkit-transition: all 0.3s ease-in-out; -o-transition: all 0.3s ease-in-out; transition: all 0.3s ease-in-out; }
        .h_d_radiobtn img,
        .h_d_radiobtn span { display: inline-block;-webkit-transition: all 0.3s ease-in-out; -o-transition: all 0.3s ease-in-out; transition: all 0.3s ease-in-out; }
        .h_d_radiobtn img { width: auto; height: 39px; }
        .h_d_radiobtn span { font-size: 12px; line-height: 16px; color: #1C3553; font-weight: 600; text-transform: capitalize; }
        /* radio btn css */
        
        /* select box css */
        .h_d_select-box-outer { position: relative; margin-bottom: 26px; }
        .h_d_select-box-outer label { position: absolute; left: 16px; top: 5px; font-size: 12px; color: #97A9BE; }
        .h_d_selectbox { background-color: #F6F7F9; color: #1C3553; font-size: 16px; font-family: 'Source Sans Pro', sans-serif; line-height: 24px; height: 56px; padding: 20px 26px 8px 16px; display: block; width: 100%; border: 0; border-top-left-radius: 4px; border-top-right-radius: 4px; border-bottom: 2px solid #B7C3D2; cursor: pointer; background-image: url(${dropdownArrow}); background-repeat: no-repeat; background-position: 95% center; -webkit-transition: all 0.3s ease-in-out; -o-transition: all 0.3s ease-in-out; transition: all 0.3s ease-in-out; }
        .h_d_selectbox:hover { border-bottom-color: #788FAB; color: #1C3553; background-image: url(${dropdownGrayArrow}); }
        .h_d_selectbox:hover + label { color: #2988FF; }
        .h_d_selectbox:disabled { border-bottom-color: #B7C3D2; background-color: #F6F7F9; color: #788FAB; cursor: not-allowed; }
        .h_d_selectbox:disabled + label { color: #788FAB; }
        .h_d_selectbox.error { color: #E00016; border-bottom-color: #E00016; background-image: url(${dropdownGrayArrow}); }
        .h_d_selectbox option{ color:  #788FAB; font-family: 'Source Sans Pro', sans-serif; color: #1C3553;}
        .h_d_select-box-outer .error-txt { display: none; font-size: 12px; color: #E00016; line-height: 16px; padding: 3px 3px 3px 16px; }
        .h_d_selectbox.error + label + .error-txt { display: block; }
        /* select box css */
        
        /* button css */
        .h_d_widget-wrapper button,
        .h_d_widget-wrapper input[type="submit"],
        .h_d_p-btn,
        .h_d_s-btn,
        .h_d_t-btn { background-color: #2988FF; color: #fff; display: block; width: 100%; padding: 12px 20px; font-weight: 600; font-size: 16px; border-radius: 2px; text-align: center; cursor: pointer; position: relative; overflow: hidden; -o-transition: all 0.5s ease-in-out; -webkit-transition: all 0.5s ease-in-out; transition: all 0.5s ease-in-out; }
        .h_d_widget-wrapper .h_d_s-btn { background-color: transparent; color: #2988FF; border: 2px solid #2988FF; }
        .h_d_widget-wrapper .h_d_t-btn { background-color: #fff; color: #2988FF; border: 2px solid #fff; }
        .h_d_p-btn:hover,
        .h_d_s-btn:hover { -webkit-box-shadow: 0px 1px 10px 0px rgb(0, 0, 0, 0.20); box-shadow: 0px 1px 10px 0px rgb(0, 0, 0, 0.20); color: #fff; background: #2988FF -o-radial-gradient(circle, transparent 1%, #2988FF 1%) center/15000%; background: #2988FF radial-gradient(circle, transparent 1%, #2988FF 1%) center/15000%; }
        .h_d_p-btn:active,
        .h_d_s-btn:active { background-color: #C2DDFF; background-size: 100%; -webkit-transition: background 0s; -o-transition: background 0s; transition: background 0s; }
        .h_d_p-btn:focus,
        .h_d_s-btn:focus { -webkit-box-shadow: 0px 0px 14px 0px rgba(24, 149, 255, 1); box-shadow: 0px 0px 14px 0px rgba(24, 149, 255, 1); }
        .h_d_p-btn:disabled,
        .h_d_s-btn:disabled,
        .h_d_p-btn:disabled:hover { background-color: #F6F7F9; color: #788FAB; background: #F6F7F9 -o-radial-gradient(circle, transparent 1%, #F6F7F9 1%) center/15000%;
            background: #F6F7F9 radial-gradient(circle, transparent 1%, #F6F7F9 1%) center/15000%; box-shadow: none; cursor: not-allowed; }
        .h_d_form-txt { font-size: 12px; line-height: 16px; display: block; text-align: center; margin-top: 16px; color: #97A9BE; }
        .h_d_widget-wrapper .h_d_t-btn:hover { background: #F5F9FF -o-radial-gradient(circle, transparent 1%, #F5F9FF 1%) center/15000%; background: #F5F9FF radial-gradient(circle, transparent 1%, #F5F9FF 1%) center/15000%; }
        .h_d_widget-wrapper .h_d_t-btn:focus { border-color: #2988FF; background-color: #E5E5E5; }
        .h_d_widget-wrapper .h_d_t-btn:active { background-color: #C2DDFF; background-size: 100%; -webkit-transition: background 0s; -o-transition: background 0s; transition: background 0s; }
        /* button css */
        
        
        /* media query */
        @media(max-width:1024px) {
            .h_d_widget-outer { max-width: 720px; }
            .h_d_widget-wrapper { font-size: 16px; }
            .h_d_widget-wrapper h1 { font-size: 24px; line-height: 32px; margin-bottom: 26px; }
            .h_d_list li { padding-left: 25px; font-size: 16px; line-height: 24px; }
            .h_d_list li:before { top: 7px; }
            .h_d_main-left{position: static;}
            .h_d_main-left:before{height: calc(100% - 26px); top: 13px; bottom: 13px; width: calc(50% + 10px)	; left: 15px;}
        }
        @media(max-width:767px) {
            .h_d_main-left { display: none; }
            .h_d_main-right { padding-left: 0; }
            .h_d_widget-wrapper h1 { font-size: 20px; line-height: 30px; }
            .h_d_mobilr-title { display: block; }
            .h_d_widget-outer { padding: 25px 19px 16px; max-width: 320px; }
            .h_d_radio { width: 88px; }
            .h_d_form-txt { display: none; }
        }
        `
    }
}